<template>
    <div class="float-left mr-1">
        <span class="text-primary">
            <i
                class="fa fa-paperclip fa-lg icon-button"
                title="Anexos"
                @click.stop="abrirModal()"
            ></i>
        </span>
        <b-modal
            id="modalComprometimentoAnexos"
            v-model="mostrarModal"
            size="xl"
            @show="preencherForm()"
        >
            <div slot="modal-title">
                Serviço {{ comprometimento.idComprometimento }} - Anexos
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <app-tabela
                idTabela="tblAnexos"
                :itens="anexos"
                :campos="campos"
                :itensPorPagina="itensPorPagina"
                :bordered="false"
            >
                <template slot="botoes">
                    <b-button-group class="float-right">
                        <inserir-anexo-form
                            v-if="mostrarBtnInserir"
                            :comprometimento="comprometimento"
                            :dataServico="dataServico"
                            @obter-anexos-atualizados="obterAnexosAtualizados()"
                        ></inserir-anexo-form>
                    </b-button-group>
                    <slot name="botoes"></slot>
                </template>
                <template slot="acoes" slot-scope="data">
                    <comprometimento-anexo-download
                        :anexo="data"
                        :dataServico="dataServico"
                        @obter-anexos-atualizados="obterAnexosAtualizados()"
                    ></comprometimento-anexo-download>
                    <comprometimento-anexo-excluir
                        v-if="mostrarBtnExcluir"
                        :comprometimento="comprometimento"
                        :anexo="data"
                        :dataServico="dataServico"
                        @obter-anexos-atualizados="obterAnexosAtualizados()"
                    ></comprometimento-anexo-excluir>
                    <slot name="acoes" v-bind="data"></slot>
                </template>
            </app-tabela>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fechar()"
                    class="mr-2"
                    >Fechar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import InserirAnexoForm from './InserirAnexoForm'
import ComprometimentoAnexoDownload from './ComprometimentoAnexoDownload'
import ComprometimentoAnexoExcluir from './ComprometimentoAnexoExcluir'

export default {
    components: {
        InserirAnexoForm,
        ComprometimentoAnexoDownload,
        ComprometimentoAnexoExcluir
    },

    props: {
        comprometimento: {
            type: Object,
            default: () => ({})
        },

        dataServico: {
            type: Object,
            default: () => {}
        },

        mostrarBtnInserir: {
            type: Boolean,
            default: () => true
        },

        mostrarBtnExcluir: {
            type: Boolean,
            default: () => true
        }
    },

    data() {
        return {
            mostrarModal: false,
            operacao: '',
            erros: [],
            anexos: [],
            campos: [
                {
                    key: 'acoes',
                    label: 'Ações'
                },
                {
                    key: 'tipoDescr',
                    label: 'Tipo',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'descritivo',
                    label: 'Descritivo',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'nomeArquivoOriginal',
                    label: 'Arquivo'
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime'
                }
            ],
            itensPorPagina: 0
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fechar() {
            this.mostrarModal = false
        },

        preencherForm() {
            this.obterAnexos()
        },

        obterAnexos() {
            this.$store.dispatch('addRequest')
            this.dataServico
                .obterComprometimentoAnexos(
                    this.comprometimento.idComprometimento
                )
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.anexos = response.data
                        } else {
                            this.$toast.error(
                                'Erro ao obter anexos!!!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        obterAnexosAtualizados() {
            this.obterAnexos()
            this.$emit('obter-atualizacao')
        }
    },

    created() {},

    computed: {},

    validations: {}
}
</script>
